import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Platform, WriteDirection } from 'sofa-reborn-react';

const borderColor = SkapaTheme.color.border.light;

export const StyledIconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 32px;
`;

export const ButtonDiv = styled.div<{
	writeDirection: WriteDirection;
	platform: Platform;
	showInfoButton: boolean;
	showRemoveButton: boolean;
}>`
	cursor: pointer;
	height: ${(props) => (props.platform === 'kiosk' ? '56px' : '32px')};
	width: ${(props) => (props.platform === 'kiosk' ? '56px' : '32px')};
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	${(props) =>
		(props.writeDirection === 'ltr' && props.showInfoButton && props.showRemoveButton) ||
		(props.writeDirection === 'rtl' && props.showRemoveButton)
			? `
					padding-left: 12px;
					border-left: 1px solid ${borderColor};
			  `
			: null}
	${(props) =>
		(props.writeDirection === 'rtl' && props.showInfoButton && props.showRemoveButton) ||
		(props.writeDirection === 'ltr' && props.showRemoveButton)
			? `
					padding-right: 12px;
					border-right: 1px solid ${borderColor};
			  `
			: null};
`;
